// @ts-nocheck: converted from JS

import { isActive } from '@/components/Glossary/Sections/Approvals/TemplateForm/Approvers.utils';
import Button from '@/components/UI/Button';
import SearchSelect from '@/components/UI/SearchSelect';
import { missingNameUseEmail } from '@/helpers';
import { _isEmpty, _notNil } from '@/littledash';
import { ApiService } from '@/support/ApiService';
import { useMemo, useState } from 'react';
import ApiErrorBanner from '@/components/ApiErrorBanner';

/**
 * Modal for adding required reviewers to a study approval request after it has been raised.
 */
const AddAdditionalReviewers = ({ approval, team, approvalRequestApiId, fetchApproval, closeModal }) => {
  const [selected, setSelected] = useState([]);
  const [addingRequiredApprover, setAddingRequiredApprover] = useState(false);
  const [requiredApproverError, setRequiredApproverError] = useState(null);

  const saveAdditionalReviewers = async () => {
    setAddingRequiredApprover(true);
    setRequiredApproverError(null);
    const requiredApiIds = selected.reduce((acc, userId) => {
      const user = team?.users?.find(({ id }) => id === userId);
      if (_notNil(user)) {
        acc.push(user.api_id);
      }
      return acc;
    }, []);
    try {
      await ApiService.call({
        endpoint: 'POST /api/v1/approvals/requests/{approvalRequestApiId}/approvers',
        path: { approvalRequestApiId },
        body: { required_api_ids: requiredApiIds },
        options: { onError: { toast: false, throw: true, slug: 'add-additional-reviewers' } },
      });
    } catch (error) {
      setRequiredApproverError(error);
      setAddingRequiredApprover(false);
      return;
    }
    closeModal();
    await fetchApproval();
  };

  const usersAlreadyAnApprover = [
    ...(approval.approval.approvers.required_ids || []),
    ...(approval.approval.approvers.ids || []),
  ];

  const sections = useMemo(() => {
    const canSelectUser = (user) => isActive(user) && !usersAlreadyAnApprover.includes(user.id);
    return [
      {
        items: team?.users?.filter(canSelectUser).map(missingNameUseEmail) || [],
      },
    ];
  }, [team]);

  return (
    <div className="center mw6 ui-card">
      <div className="pa3 bb b--moon-gray">
        <h3 className="normal lh-title f4 mb0">Add other reviewers</h3>
      </div>
      {requiredApproverError && (
        <ApiErrorBanner
          className="mb4 mw6"
          title="There was an error adding reviewers"
          text="An error has occurred when adding reviewers, please try again later. If this keeps occurring please contact support."
          error={requiredApproverError}
        />
      )}
      <SearchSelect sections={sections} selected={selected} setSelected={setSelected} sort sortAccessor={'name'} />
      <div className="pa3 bt b--moon-gray">
        <Button
          disabled={addingRequiredApprover || _isEmpty(selected)}
          onClick={saveAdditionalReviewers}
          testId="save-button"
          className="mr3"
        >
          Save
        </Button>
        <Button plain onClick={closeModal} testId="cancel-button">
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default AddAdditionalReviewers;
